"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonVisualPicturePropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var destination_1 = require("../destination");
var drawing_destination_1 = require("./drawing-destination");
var NonVisualPicturePropertiesDestination = (function (_super) {
    tslib_1.__extends(NonVisualPicturePropertiesDestination, _super);
    function NonVisualPicturePropertiesDestination(data, floatingObjectImportInfo) {
        var _this = _super.call(this, data) || this;
        _this.floatingObjectImportInfo = floatingObjectImportInfo;
        return _this;
    }
    Object.defineProperty(NonVisualPicturePropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return NonVisualPicturePropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    NonVisualPicturePropertiesDestination.OnNonVisualDrawingProperties = function (data, _reader) {
        var floatingObjectImportInfo = NonVisualPicturePropertiesDestination.getThis(data).floatingObjectImportInfo;
        return new drawing_destination_1.DrawingAnchorDocumentPropertiesDestination(data, floatingObjectImportInfo, floatingObjectImportInfo.objectNonVisualProperties);
    };
    NonVisualPicturePropertiesDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    NonVisualPicturePropertiesDestination.handlerTable = new map_creator_1.MapCreator()
        .add('cNvPr', NonVisualPicturePropertiesDestination.OnNonVisualDrawingProperties)
        .get();
    return NonVisualPicturePropertiesDestination;
}(destination_1.ElementDestination));
exports.NonVisualPicturePropertiesDestination = NonVisualPicturePropertiesDestination;
